// Estado das ligações pelo WhatsApp. Quem mexe em WebRTC é helper/whatsappCall/session.js.
import { defineStore } from 'pinia';

export const useWhatsappCallsStore = defineStore('whatsappCalls', {
  state: () => ({
    incoming: [],
    active: null,
    transcript: [],
    insights: [],
    copilotStatus: 'idle',
    permissionNeeded: {},
  }),

  getters: {
    visible: state => state.incoming.length > 0 || state.active !== null,
    // Não toca por cima de uma chamada em curso (o card continua aparecendo).
    ringing: state => state.incoming.length > 0 && state.active === null,
    isActiveConversation: state => conversationId =>
      state.active?.conversationId === conversationId,
  },

  actions: {
    addIncoming(call) {
      if (this.incoming.some(c => c.callId === call.callId)) return;
      this.incoming.push(call);
    },
    removeIncoming(callId) {
      this.incoming = this.incoming.filter(c => c.callId !== callId);
    },
    setActive(call) {
      this.active = {
        status: 'ringing',
        muted: false,
        startedAt: null,
        ...call,
      };
      this.transcript = [];
      this.insights = [];
      this.copilotStatus = 'idle';
    },
    markConnected() {
      this.active = {
        ...this.active,
        status: 'in-progress',
        startedAt: Date.now(),
      };
    },
    setMuted(muted) {
      this.active = { ...this.active, muted };
    },
    clearActive() {
      this.active = null;
      this.copilotStatus = 'idle';
    },
    addTranscript(item) {
      this.transcript.push(item);
    },
    addInsight(card) {
      this.insights.unshift({ ...card, at: Date.now() });
    },
    setCopilotStatus(status) {
      this.copilotStatus = status;
    },
    setPermissionNeeded(conversationId, needed) {
      this.permissionNeeded = {
        ...this.permissionNeeded,
        [conversationId]: needed,
      };
    },
  },
});
